import { isRecord } from '@/helpers/isRecord'

import { UserWithInternalHourBalances } from './HourBalances'

// `Number()` converts the values like the rounding of the hours always did, e.g. `null` becomes 0
export const transformToUserWithInternalHourBalances = (value: Record<string, unknown>): UserWithInternalHourBalances => ({
    id: String(value.id),
    name: typeof value.name === 'string' ? value.name : '',
    workedHours: Number(value.workedHours),
    contractHours: Number(value.contractHours),
    leaveHours: Number(value.leaveHours),
    tvtMutation: Number(value.tvtMutation),
    absenceHours: Number(value.absenceHours),
})

export const transformToUsersWithInternalHourBalances = (data: unknown): UserWithInternalHourBalances[] | undefined => {
    if (! Array.isArray(data)) {
        return undefined
    }

    return data.filter(isRecord).map(transformToUserWithInternalHourBalances)
}
